import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, FormGroup, Form, Input, Row, Col, Alert } from "reactstrap";
import TMHLoader from "../components/TMHLoader/TMHLoader.js"
import validator from 'validator'


export default function Login({ setToken }) {
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async e => {
        e.preventDefault();

        setIsError(false)

        if (!username || !password) {
            setIsError(true)
            return
        }

        if (!validator.isEmail(username)) {
            setIsError(true)
            return
        }
        setIsLoading(true)

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "username": username,
                "password": password
            }),
        };


        fetch(process.env.REACT_APP_BASE_URL + "login", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    let json = result.json
                    if (result.ok) {
                        setToken({
                            "name": json.name,
                            "user_id": json.user_id,
                            "token": json.token
                        })
                    }
                    else {
                        setIsError(true)
                        setIsLoading(false)
                    }
                },
                (error) => {
                    console.error(error)
                    setIsError(true)
                    setIsLoading(false)
                }
            )
    }

    useEffect(() => {
        document.title = 'Login - TMH Admin';
    })

    return (
            <TMHLoader active={isLoading}>
            <Col style={{ 'height': "100vh", "paddingTop": "20vh" }} className="mx-auto" md="8" sm="8" lg="4" >
                <Card className="card-user">
                    <CardBody className="text-center">
                        <Form className='author' onSubmit={handleSubmit}>
                            <div className="block block-one" />
                            <div className="block block-two" />
                            <div className="block block-three" />
                            <div className="block block-four" />
                            <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                <h2 className="title">Login</h2>
                            </a>
                            <Row>
                                <Col className="mx-auto" md="6">
                                    <FormGroup>
                                        <label htmlFor="exampleInputEmail1">
                                            Email address
                                        </label>
                                        <Input type="text" placeholder="Email" onChange={e => setUserName(e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mx-auto" md="6">
                                    <FormGroup>
                                        <label htmlFor="exampleInputEmail1">
                                            Password
                                        </label>
                                        <Input type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
                                    </FormGroup>
                                </Col>

                            </Row>


                            <Button className="btn-fill text-center" color="primary" type="submit">
                                Save
                            </Button>
                        </Form>
                    </CardBody>
                </Card>
                {isError && <Alert color="danger">Please enter valid credentials</Alert>}
            </Col>
        </TMHLoader>
    )
}